
export default {
    filters: {
        
    },
    data() {
        return {
            datepicker_lang :{
                formatLocale: {
                    months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                    monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                    weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
                    weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
                    weekdaysMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
                },                   
            },
            datatable_lang : {
                processing: "Procesando...",
                lengthMenu : "Mostrar _MENU_ registros por página",
                zeroRecords: "No hay ningun registro",
                info: "Mostrando _PAGE_ de _PAGES_",
                infoEmpty: "No hay registros",
                infoFiltered: "(filtrados de _MAX_ registros)",
                sSearch:         "Buscar:",
                paginate: {
                    next: ">",
                    previous: "<"
                }
            },
        }
    },
    components: {
    },
    mounted() {
       
    },
    methods: {
     
    },
}
